export default __webpack_public_path__ + "static/media/furiousinspiration.04801401.png";